import { createElement } from 'react';
import { node, string } from 'prop-types';
import { columnSpreadPropType, columnSpreadOffsetPropType } from '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import ColumnsContext from '../Columns/ColumnsContext.js';
import _Column from './styled.js';

var Column = function Column(_ref) {
  var children = _ref.children,
      className = _ref.className,
      spread = _ref.spread,
      spreadMobile = _ref.spreadMobile,
      spreadTablet = _ref.spreadTablet,
      spreadDesktop = _ref.spreadDesktop,
      spreadWidescreen = _ref.spreadWidescreen,
      spreadFullHD = _ref.spreadFullHD,
      spreadOffset = _ref.spreadOffset,
      spreadMobileOffset = _ref.spreadMobileOffset,
      spreadTabletOffset = _ref.spreadTabletOffset,
      spreadDesktopOffset = _ref.spreadDesktopOffset,
      spreadWidescreenOffset = _ref.spreadWidescreenOffset,
      spreadFullHDOffset = _ref.spreadFullHDOffset,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "className", "spread", "spreadMobile", "spreadTablet", "spreadDesktop", "spreadWidescreen", "spreadFullHD", "spreadOffset", "spreadMobileOffset", "spreadTabletOffset", "spreadDesktopOffset", "spreadWidescreenOffset", "spreadFullHDOffset"]);

  return createElement(ColumnsContext.Consumer, null, function (_ref2) {
    var isGapless = _ref2.isGapless,
        minBreakpoint = _ref2.minBreakpoint;
    return createElement(_Column, _extends({
      className: className,
      isGapless: isGapless,
      minBreakpoint: minBreakpoint,
      spread: spread,
      spreadMobile: spreadMobile,
      spreadTablet: spreadTablet,
      spreadDesktop: spreadDesktop,
      spreadWidescreen: spreadWidescreen,
      spreadFullHD: spreadFullHD,
      spreadOffset: spreadOffset,
      spreadMobileOffset: spreadMobileOffset,
      spreadTabletOffset: spreadTabletOffset,
      spreadDesktopOffset: spreadDesktopOffset,
      spreadWidescreenOffset: spreadWidescreenOffset,
      spreadFullHDOffset: spreadFullHDOffset
    }, props), children);
  });
};

var columnPropTypes = {
  children: node.isRequired,
  className: string,
  spread: columnSpreadPropType,
  spreadMobile: columnSpreadPropType,
  spreadTablet: columnSpreadPropType,
  spreadDesktop: columnSpreadPropType,
  spreadWidescreen: columnSpreadPropType,
  spreadFullHD: columnSpreadPropType,
  spreadOffset: columnSpreadOffsetPropType,
  spreadMobileOffset: columnSpreadOffsetPropType,
  spreadTabletOffset: columnSpreadOffsetPropType,
  spreadDesktopOffset: columnSpreadOffsetPropType,
  spreadWidescreenOffset: columnSpreadOffsetPropType,
  spreadFullHDOffset: columnSpreadOffsetPropType
};
Column.propTypes = columnPropTypes;
var columnDefaultProps = {
  className: undefined,
  spread: undefined,
  spreadMobile: undefined,
  spreadTablet: undefined,
  spreadDesktop: undefined,
  spreadWidescreen: undefined,
  spreadFullHD: undefined,
  spreadOffset: undefined,
  spreadMobileOffset: undefined,
  spreadTabletOffset: undefined,
  spreadDesktopOffset: undefined,
  spreadWidescreenOffset: undefined,
  spreadFullHDOffset: undefined
};
Column.defaultProps = columnDefaultProps;
var C = Column;
export default C;
export { C as Column, columnDefaultProps, columnPropTypes };